const replaceEventTitlePlaceholder = (textPayload: string, eventTitle?: string) =>
    eventTitle
        ? textPayload.replaceAll(/{{event_title}}/gmi, eventTitle)
        : textPayload;

export default replaceEventTitlePlaceholder;
